import React, { memo } from 'react';
import { FaSpinner } from 'react-icons/fa';

const Table = memo(({ 
  columns = [],
  data = [],
  loading = false,
  emptyMessage = 'No data available',
  className = '',
  style = {},
  onRowClick,
  ...props 
}) => {
  const tableStyles = {
    width: '100%',
    borderCollapse: 'collapse',
    backgroundColor: 'white',
    ...style
  };

  const headerStyles = {
    backgroundColor: '#f9fafb',
    borderBottom: '1px solid #e5e7eb',
    padding: '12px 8px',
    textAlign: 'left',
    fontSize: '12px',
    fontWeight: '600',
    color: '#374151'
  };

  const cellStyles = {
    padding: '12px 8px',
    borderBottom: '1px solid #f3f4f6',
    fontSize: '14px',
    color: '#374151'
  };

  const rowStyles = {
    cursor: onRowClick ? 'pointer' : 'default',
    '&:hover': onRowClick ? {
      backgroundColor: '#f9fafb'
    } : {}
  };

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '200px',
        backgroundColor: 'white',
        borderRadius: '8px',
        border: '1px solid #e5e7eb'
      }}>
        <FaSpinner style={{ animation: 'spin 1s linear infinite', fontSize: '32px', color: '#3b82f6' }} />
        <p style={{ marginTop: '12px', color: '#6b7280' }}>Loading...</p>
      </div>
    );
  }

  if (data.length === 0) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '200px',
        backgroundColor: 'white',
        borderRadius: '8px',
        border: '1px solid #e5e7eb'
      }}>
        <p style={{ color: '#6b7280' }}>{emptyMessage}</p>
      </div>
    );
  }

  return (
    <div style={{ overflow: 'auto', borderRadius: '8px', border: '1px solid #e5e7eb' }}>
      <table className={className} style={tableStyles} {...props}>
        <thead>
          <tr>
            {columns.map((column, index) => (
              <th key={index} style={headerStyles}>
                {column.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <tr 
              key={rowIndex} 
              style={rowStyles}
              onClick={() => onRowClick && onRowClick(row, rowIndex)}
            >
              {columns.map((column, colIndex) => (
                <td key={colIndex} style={cellStyles}>
                  {column.render ? column.render(row[column.key], row, rowIndex) : row[column.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
});

export default Table;

Table.displayName = 'Table';
